// --------------------------------------------------------------------------
// Expiry Date (part of #206 Payment Form)
// --------------------------------------------------------------------------
// Author:      Zone
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2016, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var events = require('common-js-pub-sub')();

module.exports = function (options) {
    var context = options.context;
    var expiryYear = context.find('[data-binding="credit-card-expiry-year"]');
    var expiryMonth = context.find('[data-binding="credit-card-expiry-month"]');
    var xExpiryDate = context.find('input[name="x_exp_date"]');

    function dateIsInThePast(date) {
        var today = new Date();
        var isInThePast = date < today;

        if (isInThePast) {
            return true;
        } else {
            return false;
        }
    }

    function updateExpiryDate(month, year) {
        xExpiryDate.val(month + year);

        if (month !== '0' && year !== '') {
            var date = new Date(parseInt(year), parseInt(month), 0);
            if (dateIsInThePast(date)) {
                // show error
                events.publish('custom-error', {
                    element: expiryMonth,
                    message: 'Oh dear! It looks like your card has expired. Please can you use one that\'s still valid? Thanks!'
                });
            } else {
                events.publish('remove-custom-error', {
                    element: expiryMonth
                });
            }
        }
    }

    function monthUpdated() {
        var month = expiryMonth.val() < 10 ? '0' + expiryMonth.val() : expiryMonth.val();
        var year = expiryYear.val() === '' ? '' : expiryYear.val();

        updateExpiryDate(month, year);
    }

    function yearUpdated() {
        var month = expiryMonth.val() < 10 ? '0' + expiryMonth.val() : expiryMonth.val();
        var year = expiryYear.val() !== '' ? expiryYear.val() : '';

        updateExpiryDate(month, year);
    }

    function init() {
        expiryMonth.on('change', function () {
            monthUpdated();
        });

        expiryYear.on('change', function () {
            yearUpdated();
        });
    }

    events.subscribe('custom-error', function (options) {
        var element = options.element;
        var message = options.message;
        var errorSpan = element.siblings('[class*="field-validation"]');
        errorSpan.removeClass('field-validation-valid').addClass('field-validation-error').text(message);
    });

    events.subscribe('remove-custom-error', function (options) {
        var element = options.element;
        var errorSpan = element.siblings('[class*="field-validation"]');
        errorSpan.removeClass('field-validation-error').addClass('field-validation-valid').empty();
    });

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/forms/expiry-date.js
// module id = 270
// module chunks = 0